<img src="assets/shared/global-images/icon-set/copy-white.svg">
<span
  payee-ripple
  [payeeRippleDisabled]="disableRipple"
  [payeeRippleTrigger]="element"
  [attr.color]="color"
  class="payee-round-button-ripple"
></span>